import { api } from './auth.service';

const configSistemaService = {
  // Lista configs (com filtro opcional por prefixo)
  listar: async (prefixo) => {
    const params = prefixo ? `?prefixo=${encodeURIComponent(prefixo)}` : '';
    const r = await api.get(`/config-sistema${params}`);
    return r.data;
  },

  // Atualiza várias chaves em lote
  atualizarLote: async (chaves, usuarioId) => {
    const r = await api.put('/config-sistema', { chaves, usuario_id: usuarioId });
    return r.data;
  },
};

export default configSistemaService;
